import {Injectable} from '@angular/core';
import {ExgMapBicyclingLayerDirective} from '../../exg-map-bicycling-layer/exg-map-bicycling-layer.directive';
import {ExgMapTransitLayerDirective} from '../../exg-map-transit-layer/exg-map-transit-layer.directive';
import {ExgMapGoogleAPIWrapper} from '../exg-map-google-api-wrapper.service';

/**
 * This class manages Transit and Bicycling Layers for a Google Map instance.
 */

@Injectable()
export class ExgMapLayerManagerService {
  private _layers: Map<ExgMapTransitLayerDirective |
    ExgMapBicyclingLayerDirective, Promise<google.maps.TransitLayer | google.maps.BicyclingLayer>> =
    new Map<ExgMapTransitLayerDirective | ExgMapBicyclingLayerDirective, Promise<google.maps.TransitLayer | google.maps.BicyclingLayer>>();

  constructor(private _wrapper: ExgMapGoogleAPIWrapper) {
  }

  /**
   * Adds a transit layer to a map instance.
   * @param layer - a TransitLayer object
   * @param _options - TransitLayerOptions options
   * @returns void
   */
  addTransitLayer(layer: ExgMapTransitLayerDirective): void {
    const newLayer = this._wrapper.createTransitLayer();
    this._layers.set(layer, newLayer);
  }

  /**
   * Adds a bicycling layer to a map instance.
   * @param layer - a bicycling layer object
   * @param _options - BicyclingLayer options
   * @returns void
   */
  addBicyclingLayer(layer: ExgMapBicyclingLayerDirective): void {
    const newLayer = this._wrapper.createBicyclingLayer();
    this._layers.set(layer, newLayer);
  }

  /**
   * Deletes a map layer
   * @param layer - the layer to delete
   */
  deleteLayer(layer: ExgMapTransitLayerDirective | ExgMapBicyclingLayerDirective): Promise<void> {
    // @ts-ignore
    return this._layers.get(layer).then(currentLayer => {
      currentLayer.setMap(null);
      this._layers.delete(layer);
    });
  }
}
